import { render, staticRenderFns } from "./learningPotential.vue?vue&type=template&id=6cd31c64"
import script from "./learningPotential.vue?vue&type=script&lang=js"
export * from "./learningPotential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports